var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeVisible(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A6A6",
    fillRule: "nonzero",
    d: "M8.589 6.088a1 1 0 1 0 1.323 1.323A2 2 0 0 1 8 10a2 2 0 1 1 .589-3.912zM8 13C5.241 13 2.727 11.538.457 8.613a1 1 0 0 1 0-1.226C2.727 4.462 5.24 3 8 3c2.759 0 5.273 1.462 7.543 4.387a1 1 0 0 1 0 1.226C13.273 11.538 10.76 13 8 13zm0-1a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeVisible);
export default __webpack_public_path__ + "static/media/eye-visible.16fa7c53fac56f1fe34505b850b14996.svg";
export { ForwardRef as ReactComponent };